import { ISetCookieOptions, SameSite, getCookie, isHttps, setCookie, unsetCookie } from 'rev-shared/util/CookieUtil';

export function canSetCookies(): boolean {
	return testCookie() || isHttps && testCookie({ sameSite: SameSite.None });
}

function testCookie(options?: ISetCookieOptions): boolean {
	const cookie = 'test-cookie';
	setCookie(cookie, '1', options);
	const result = !!getCookie(cookie);
	unsetCookie(cookie);

	return result;
}

export function hasStorageAccess(): Promise<void> {
	const doc = document as any;
	if(!doc.hasStorageAccess) {
		if(!canSetCookies()) {
			console.log('Unable to set cookies, document.hasStorageAccess is null');
			return Promise.reject();
		}
		return Promise.resolve();
	}

	return doc.hasStorageAccess()
		.then(access => {
			console.log('document.hasStorageAccess:', access);
			if(!access) {
				return Promise.reject();
			}
		});
}

export function requestStorageAccess(): Promise<void> {
	const doc = document as any;
	if(!doc.requestStorageAccess) {
		return Promise.resolve();
	}

	return doc.requestStorageAccess()
		.then(() => console.log('document.requestStorageAccess ok'))
		.catch(err => {
			console.log('document.requestStorageAccess rejected: ', err);
			return Promise.reject();
		});
}
